module.exports = __webpack_public_path__ + "static/img/1_2_2.11b570a3.jpg";